import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ element }) => {
  const { loginIsValid } = useAuth();

  if (!loginIsValid) {
    return <Navigate to="/login" />;
  }

  return element;
};

export default ProtectedRoute;
